import React, { useState } from "react";
import { GiCakeSlice, GiPartyPopper, GiBalloons } from "react-icons/gi";
import { BsStars } from "react-icons/bs";
import { cloudFrontUrl } from "../../nestserver";

export default function BirthdayCard({ data }) {
  const name = `${data?.first_name ?? ""} ${data?.last_name ?? ""}`.trim();
  const [imgError, setImgError] = useState(false);

  const fallbackSrc =
    "https://ui-avatars.com/api/?name=" +
    encodeURIComponent(data?.first_name || "?") +
    "&background=fbcfe8&color=be185d";

  const imgSrc =
    !imgError && data?.profile_image
      ? cloudFrontUrl + "/" + data?._id + "/" + data?.profile_image
      : fallbackSrc;

  return (
    <div
      className="relative shrink-0 grow-0 w-64 rounded-2xl px-6 pt-8 pb-6 flex flex-col items-center overflow-visible"
      style={{
        background:
          "linear-gradient(135deg, #fff0f6 0%, #fff2e2 50%, #fffbea 100%)",
        border: "1.5px solid #f9a8d4",
        boxShadow: "0 6px 20px rgba(236, 72, 153, 0.22)",
      }}
    >
      {/* Decorative icons — spread further out, more variety, behind content */}
      <BsStars className="absolute top-3 left-3 text-amber-400 text-lg opacity-70 animate-pulse pointer-events-none z-0" />
      <BsStars
        className="absolute top-3 right-3 text-pink-400 text-base opacity-70 animate-pulse pointer-events-none z-0"
        style={{ animationDelay: "0.4s" }}
      />
      <GiBalloons
        className="absolute top-14 left-2 text-pink-300 text-xl opacity-60 pointer-events-none z-0"
        style={{ transform: "rotate(-12deg)" }}
      />
      <GiPartyPopper
        className="absolute top-14 right-2 text-amber-400 text-xl opacity-60 pointer-events-none z-0"
        style={{ transform: "rotate(12deg)" }}
      />
      <BsStars
        className="absolute bottom-3 left-3 text-amber-300 text-sm opacity-60 animate-pulse pointer-events-none z-0"
        style={{ animationDelay: "0.8s" }}
      />
      <BsStars
        className="absolute bottom-3 right-3 text-pink-300 text-sm opacity-60 animate-pulse pointer-events-none z-0"
        style={{ animationDelay: "1.2s" }}
      />

      {/* Avatar */}
      <div className="relative z-10 shrink-0" style={{ width: 92, height: 92 }}>
        <span className="absolute inset-0 rounded-full bg-pink-400 opacity-40 animate-ping" />
        <img
          className="absolute inset-0 w-full h-full object-cover rounded-full ring-2 ring-pink-400"
          style={{ width: 92, height: 92 }}
          src={imgSrc}
          onError={() => setImgError(true)}
          alt={name}
        />
        <span
          className="absolute -bottom-1 -right-1 bg-linear-to-br from-pink-500 to-orange-400 text-white rounded-full w-9 h-9 flex items-center justify-center shadow-md ring-2 ring-white animate-bounce z-20"
          title="Birthday today!"
        >
          <GiCakeSlice className="text-base" />
        </span>
      </div>

      {/* Name + class — more breathing room */}
      <div className="relative z-10 mt-5 w-full text-center">
        <div className="text-base font-bold text-pink-600 truncate">
          {name || "—"}
        </div>
        {data?.class?.name && (
          <div className="mt-1 text-xs font-semibold text-amber-600 truncate">
            Class: {data.class.name}
          </div>
        )}
      </div>

      <div className="relative z-10 mt-4 text-xs font-bold text-pink-500 animate-pulse text-center">
        🎉 Happy Birthday!
      </div>
    </div>
  );
}
